export default __webpack_public_path__ + "static/media/icon-coin-mog.0ac07dda.svg";